import { Text } from '@react-pdf/renderer';
import React from 'react';
import { getFontFamily } from '../../../badge/pdf/utils';
import { FONT } from '../../../types/enums';
import { getStringWithMultipleReplacements } from '../ReceiptPdf.utils';
import { receiptPriceReplacements } from '../ReceiptPdf.constants';
import { Style } from "@react-pdf/types";

type Props = { label: string; value: string, labelStyles?: Style; labelSubtitleStyles?: Style };

const LabelValue: React.FC<Props> = ({ label, value, labelStyles = {}, labelSubtitleStyles = {} }) => {
  return (
    <Text style={{ fontSize: 13, display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '5px' }}>
      <Text style={[getFontFamily(label, { fallbackFont: FONT.HELVETICA_BOLD, bold: true }), labelStyles]}>{label.split('')}: </Text>
      <Text wrap={true} style={[{ fontSize: 13, flexWrap: 'wrap' }, getFontFamily(value), labelSubtitleStyles]}>
        {getStringWithMultipleReplacements(value, receiptPriceReplacements).split('')}
      </Text>
    </Text>
  );
};

export default LabelValue;
